module.exports = __webpack_public_path__ + "img/hohlova.54b1d3b9.jpg";